module.exports = __webpack_public_path__ + "media/images/products/template/01/07-514e5f3b16a56cb045c3f6431bf23688.jpg";